import { useState } from 'react';
import "./Footer.css";

const Footer = () => {
  // Состояние для попапа (опционально, если нужна интерактивность)
  const [showPopup, setShowPopup] = useState(false);

  const handlePercentClick = () => {
    setShowPopup(true);
    setTimeout(() => setShowPopup(false), 4000); // Закрыть через * секунды
  };

  return (
    <div id="footer" aria-label="Футер сайта">
      <div className="footer">
        <div className="ilike">
          <p>&nbsp;</p>
          <button
            className="ilike_but_top"
            onClick={handlePercentClick}
            aria-label="Информация о прогрессе издания"
          >
            Издание книги «Сын Люцифера»
          </button>
          {showPopup && (
            <div className="percent-popup">
              <p>Текущий прогресс: 4 %</p>
            </div>
          )}
        </div>
        <div className="copy">
          <p>Все права защищены Ⓒ 2011-2025 Сергей Мавроди Официальный сайт</p>
        </div>
      </div>
    </div>
  );
};

export default Footer;